import {
    replaceClickMenuKeywords,
    hideSubMenu,
    hideClickMenu,
    showClickMenu,
    cancelClickHide,
    getElement, matchesDisplayFlags, showSubMenu
} from "./helpers";
import {loadUrl} from "../../common/url";
import {
    calculateLeftPosition,
    calculateTopPosition,
    CA_getContainerHeight,
    CA_getContainerWidth, getCursorPosition
} from "../../common/window";
import {showLargeReport, showReport} from "../../common/nav";
import {addStyleClass, hasStyleClass, removeStyleClass} from "../../common/colors";


const ALL_TRUE_DISPLAY_FLAGS = ['*'];
const VALID_DISPLAY_FLAGS_REGEX = /[_*!a-zA-Z0-9]+/g;

/**
 * Loads Click Menu logic.
 * 	- Some pages, like the Matrix page, will have multiple click menus.
 *
 * Click Menu related components:
 * 	- Clickable Row: A row in a Listing Table.
 * 	- Click Menu: The popup menu that appears after clicking a Clickable Row.
 * 	- Click Menu Row: A row in the Click Menu.
 * 	- Click Category: A sub menu found in Click Menu. These contain Click Menu Rows.
 */
export function loadClickMenu() {
    // Retrieve all clickMenu elements.
    const clickMenus = document.querySelectorAll('.clickMenu');
    if (!clickMenus || clickMenus.length === 0) {
        console.error("Failed to find required 'clickMenu' element...");
        return;
    }

    GlobalEnt.clickMenu.defaultMenuId = clickMenus[0].id;
    applyShowSubMenuLogicToClickMenuRows();
    applyClickListenerToClickMenuRows(clickMenus);
}

function applyShowSubMenuLogicToClickMenuRows() {
    const categories = document.querySelectorAll('.clickCategory');
    if (!categories) {
        return;
    }

    for (let i = 0; i < categories.length; i++) {
        categories[i].addEventListener('click', function(e) {
            const clickSubMenu = categories[i].querySelector('.clickSubMenu');
            if (clickSubMenu) {
                const clickSubMenuFirstRow = clickSubMenu.querySelector('.clickMenuRow');
                if (clickSubMenuFirstRow) {
                    clickSubMenuFirstRow.click();
                }
            }
        });

        categories[i].addEventListener('mouseover', function(e) {
            showSubMenu(categories[i]);
        });
    }
}

function applyClickListenerToClickMenuRows(clickMenus) {
    for (let i = 0; i < clickMenus.length; i++) {
        const clickMenuDataset = clickMenus[i].dataset;
        const escPageId = clickMenuDataset.escPageId;

        const rows = clickMenus[i].querySelectorAll('.clickMenuRow');
        if (rows) {
            for (let j = 0; j < rows.length; j++) {
                if (escPageId)
                    rows[j].setAttribute('data-esc-page-id', escPageId);
                rows[j].addEventListener('click', getClickListener);
            }
        } else {
            console.warning("No click menu rows are included in the click menu...");
        }
    }
}

function getClickListener(evt) {
    evt.preventDefault();

    const element = getAnchorElement(evt);
    if (!element) {
        console.warning("Failed to find element... ", evt);
        return;
    }

    const { link, targetParent, useShowReport, useShowLargeReport, useCustomJs,
        escPageId, openInNewWindow } = element.dataset;

    if (useCustomJs === 'true') {
        return;
    }

    const urlLink = replaceClickMenuKeywords(link);
    if (useShowReport === 'true') {
        showReport(urlLink);
        return;
    } else if (useShowLargeReport === 'true') {
        showLargeReport(urlLink);
        return;
    }

    loadUrl(urlLink, escPageId, targetParent, openInNewWindow === 'true');
}

function getAnchorElement(evt) {
    if (evt.target.tagName === 'a') {
        return evt.target;
    }
    return evt.target.closest('a');
}

export function showRowMenu(evt, rowEl, menuId, displayFlags) {
    const { listPageLogic, clickMenu, dbMenu } = GlobalEnt;
    const flags = getDisplayFlags(displayFlags);

    recordLastSelectedRow(rowEl, listPageLogic);
    clearPendingColorChange(clickMenu.clickedElem);

    let clickedElem = getElement(evt);
    if (canShowMenuForThisElement(clickedElem)) {
        clickedElem = getParentTr(clickedElem);

        popupMenu(evt, rowEl, menuId, flags);

        if (dbMenu)
            dbMenu.hidePrevious();

        // set the background to the hover background color by switching the element class
        addStyleClass(clickedElem, 'selectedClickRow');
    }
    else {
        clickedElem = null;
    }

    GlobalEnt.clickMenu.clickedElem = clickedElem;
}

const getDisplayFlags = (displayFlags) => {
    if (!displayFlags)
        return ALL_TRUE_DISPLAY_FLAGS;
    return displayFlags.match(VALID_DISPLAY_FLAGS_REGEX);
};

const recordLastSelectedRow = (rowEl, listPageLogic) => {
    if (rowEl.id && listPageLogic && listPageLogic.sendAutoScrollRowId) {
        listPageLogic.sendAutoScrollRowId(rowEl.id);
    }
}

const clearPendingColorChange = (clickedEl) => {
    if (clickedEl == null)
        return;
    removeStyleClass(clickedEl, 'selectedClickRow');
}

const getParentTr = (clickedEl) => {
    let parentEl = clickedEl;
    while (parentEl != null && parentEl.tagName !== 'TR') {
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}

const canShowMenuForThisElement = (clickedEl) => {
    return clickedEl.tagName === 'TD'
        || hasStyleClass(clickedEl, 'clickable')
        && !hasStyleClass(clickedEl, 'nonClickable');
};

export function popupLocGfxMenu(evt, menuId, rowId, displayFlags) {
    if (!displayFlags)
        displayFlags = ['*'];

    cancelClickHide();

    GlobalEnt.clickMenu.rowId = rowId;
    GlobalEnt.clickMenu.optParam1 = null;
    GlobalEnt.clickMenu.optParam2 = null;
    GlobalEnt.clickMenu.clickMenuShowIndex += 1;
    GlobalEnt.clickMenu.hideTimer = 0;

    performPopup(evt, menuId, null, displayFlags);
}

export function popupMenu(evt, rowEl, menuId, displayFlags) {
    if (!(rowEl instanceof Element)) {
        rowEl = document.getElementById(rowEl);
    }

    if (!rowEl) {
        console.error("Failed to load rowEl in popupMenu...");
        return;
    }

    if (!displayFlags)
        displayFlags = ['*'];

    cancelClickHide();

    const dataset = rowEl.dataset;
    GlobalEnt.clickMenu.rowId = dataset.rowId;
    GlobalEnt.clickMenu.optParam1 = dataset.optParam1;
    GlobalEnt.clickMenu.optParam2 = dataset.optParam2;
    GlobalEnt.clickMenu.clickMenuShowIndex += 1;
    GlobalEnt.clickMenu.hideTimer = 0;

    performPopup(evt, menuId, rowEl, displayFlags);
}


export function performPopup(evt, menuId, rowEl, displayFlags) {
    const clickMenuEl = document.getElementById(menuId);
    if (!clickMenuEl) {
        console.error("Failed to find the click menu for: " + menuId);
        return;
    }

    if (typeof(displayFlags) == 'undefined' || displayFlags == null)
        displayFlags = ['*'];  //all flags are true

    const listElms = clickMenuEl.getElementsByTagName("li");
    if (listElms) {
        for (let i = 0; i < listElms.length; i++) {
            if (matchesDisplayFlags(listElms[i], displayFlags))
                listElms[i].style.display = 'block';
            else
                listElms[i].style.display = 'none';
        }
    }

    const cursor = getCursorPosition(evt);
    let cursorY = cursor.y;

    // Account for system messages.
    const frmSystemMessage = document.FrmSystemMessage;
    if (frmSystemMessage && frmSystemMessage.dataset.isManageSection) {
        cursorY -= frmSystemMessage.clientHeight + 30;
    }

    const bHeight = CA_getContainerHeight();
    const bWidth = CA_getContainerWidth();

    /* display now, so that width and height values are defined and non-zero */
    clickMenuEl.style.display = "block";

    const firstRow = rowEl ? rowEl.querySelector("a") : null;
    const firstRowOffsetHeight = firstRow ? firstRow.offsetHeight : 19;

    const body = document.getElementsByClassName('body-container')[0];
    const container = document.getElementsByClassName('body')[0];
    const barHeight = container ? (54 + container.offsetTop) : 0;

    const isTreeDisplayed = (document.querySelector('.tree-container')
            && !document.querySelector('.content-container').classList.contains('tree-collapsed'))
        || document.querySelector('.treeContainerFilterOnly');
    const treeWidth = isTreeDisplayed ? 230 : 0;

    var offsetLeft = container ? container.offsetLeft : 0;
    var scrollTop = body ? body.scrollTop : 0;

    if (bHeight > (cursorY + clickMenuEl.offsetHeight)) {
        if ((bWidth * 0.85) > cursor.x) {
            clickMenuEl.style.left = (cursor.x - 10 - treeWidth - offsetLeft) + "px";
            clickMenuEl.style.top = cursorY - (firstRowOffsetHeight / 2) + scrollTop - barHeight + "px";
        } else {
            clickMenuEl.style.left = (cursor.x - clickMenuEl.offsetWidth + 10 - treeWidth - offsetLeft) + "px";
            clickMenuEl.style.top = (cursorY - (firstRowOffsetHeight / 2) + scrollTop - barHeight) + "px";
        }
    } else {
        if ((bWidth * 0.85) > cursor.x) {
            clickMenuEl.style.left = (cursor.x - 10 - treeWidth - offsetLeft) + "px";
            clickMenuEl.style.top = (cursorY - clickMenuEl.offsetHeight +
                scrollTop + (firstRowOffsetHeight / 2)) - barHeight + "px";
        } else {
            clickMenuEl.style.left = (cursor.x - clickMenuEl.offsetWidth + 10 - treeWidth - offsetLeft) + "px";
            clickMenuEl.style.top = (cursorY - clickMenuEl.offsetHeight +
                scrollTop + (firstRowOffsetHeight / 2)) - barHeight + "px";
        }
    }

    clickMenuEl.focus();

    if (!("ontouchstart" in window)) { // desktop
        clickMenuEl.addEventListener('mouseleave', function() {
            hideClickMenu();
        });
        clickMenuEl.addEventListener('mouseover', function() {
            showClickMenu();
        });
    } else { // touch device
        const clickMenuShowIndex = GlobalEnt.clickMenu.clickMenuShowIndex;

        const hideMenu = function(e) {
            let target = e && typeof e == "object" ? e.target : null;
            while (target) {
                if (target === clickMenuEl)
                    return; // just clicked in the click menu - abort menu hide
                target = target.parentNode;
            }

            // Hide the click menu unless we are opening it elsewhere.
            if (clickMenuShowIndex === GlobalEnt.clickMenu.clickMenuShowIndex) {
                hideClickMenu();
            } else {
                hideSubMenu();
            }

            document.removeEventListener("click", hideMenu);
        };

        // Add listener in timeout so handler to close click menu isn't triggered by current event
        setTimeout(function() {
            document.addEventListener('click', function() {
                hideMenu();
            })
        }, 0);
    }

    GlobalEnt.clickMenu.currentlyShowingMenu = clickMenuEl;
}

export function hasClickMenuTag() {
    return document.querySelector('.clickMenu');
}